import * as keyboardKey from 'keyboard-key';
import * as _ from 'lodash';
var keyboardHandlerFilter = function (handler, keysCombinations) { return function (event) {
    var shiftKey = event.shiftKey, altKey = event.altKey, metaKey = event.metaKey, ctrlKey = event.ctrlKey;
    var isHandled = _.some(keysCombinations, function (keysCombination) {
        return keysCombination.keyCode === keyboardKey.getCode(event) &&
            (!keysCombination.altKey || altKey) &&
            (!keysCombination.shiftKey || shiftKey) &&
            (!keysCombination.metaKey || metaKey) &&
            (!keysCombination.ctrlKey || ctrlKey);
    });
    if (isHandled) {
        handler(event);
    }
}; };
export default keyboardHandlerFilter;
